// extracted by mini-css-extract-plugin
export default {"CartQuantityUpdateSuccessToast__Image":"CartQuantityUpdateSuccessToast-styles__CartQuantityUpdateSuccessToast__Image__DTsFu"};